import { defineMessages } from 'react-intl';

export const conditionVoucherInfoMessages = defineMessages({
  discountAmountPercentageFromPiece: {
    id: 'pd.upselling.condition.voucher.info.percentage.from.piece',
    defaultMessage:
      'Přidejte ještě <b>{targetAmount} ks</b> pro slevu <b>{discount} %</b> s kupónem <b>{coupon}</b>',
  },
  discountAmountAbsoluteFromPiece: {
    id: 'pd.upselling.condition.voucher.info.absolute.from.piece',
    defaultMessage:
      'Přidejte ještě <b>{targetAmount} ks</b> pro slevu <b>{discount}</b> s kupónem <b>{coupon}</b>',
  },
  discountAmountPercentageFromPrice: {
    id: 'pd.upselling.condition.voucher.info.percentage.from.price',
    defaultMessage:
      'Nakupte ještě za <b>{targetAmount}</b> pro slevu <b>{discount} %</b> s kupónem <b>{coupon}</b>',
  },
  discountAmountAbsoluteFromPrice: {
    id: 'pd.upselling.condition.voucher.info.absolute.from.price',
    defaultMessage:
      'Nakupte ještě za <b>{targetAmount}</b> pro slevu <b>{discount}</b> s kupónem <b>{coupon}</b>',
  },
});
